// frontend/src/utils/toArray.js
export function toArray(x) {
  return Array.isArray(x) ? x : x ? [x] : [];
}
